import raw from "../../rawClients/rawCapiClient";
import routes from "../../capiRoutes";
import uploadSerializer from "../../serializers/upload";
export default {
  /**
   * This function does not pass through namespace to the backend.
   * This means that your document will show up in the documents list on the project
   */
  createAttachmentInProject(projectUid, { name, contentType, folder }) {
    return raw.post(
      routes.attachments.uploads(projectUid),
      uploadSerializer.toServer({ name, contentType, folder })
    );
  },
};
